import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext';
import { hasMinimumRole } from '@/constants';

/**
 * Role-based route guard.
 * Redirects to dashboard (or custom path) if user lacks required role.
 *
 * @param {string} requiredRole - Minimum role needed
 * @param {string} [redirectTo='/dashboard'] - Where to redirect on insufficient role
 */
export function RoleGuard({ children, requiredRole, redirectTo = '/dashboard' }) {
    const { user } = useAuthContext();

    if (!user || !hasMinimumRole(user.role, requiredRole)) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
}

export default RoleGuard;
